import { axios as client } from './apiAdmin'
import { exportFile } from '../requestDownloadFile'
export const productsExportApi = {
    getSellerConnections: data => {
    return client.get('product/export/tasks', { params: data }).then(res => res)
    },
    downloadTask: data => {
    return exportFile(`product/export/tasks/${data.id}/download`, data.qs, data.fileName, data.platform)
    },
    cancelTask: data => {
    return client.post(`product/export/tasks/${data.id}/cancel`, data ).then(res => res)
    },
    retryTask: data => {
    return client.post(`product/export/tasks/${data.id}/retry`,  data ).then(res => res)
    },
    createTask: data => { 
    return client.post('product/export/tasks', data ).then(res => res)
    },
}